import { Injectable, Injector, QueryList } from "@angular/core";
import { PoDynamicFormField, PoTableColumn, PoTableComponent } from "@po-ui/ng-components";
import { HeaderOption, MingleService } from "@totvs/mingle";
import { LiteralsWords } from "src/app/i18n/literals.model";
import { VehicleField } from 'src/app/shared/models/pgc-vehicle.model';
import { LiteralsService } from "../services/literals-service";
import { DateHandler } from "./date-handler";
import { PgcProfileItem } from "../models/pgc-profile.model";
import { PreferencesProfileService } from "../services/preferences-profile.service";
import { LoginService } from "../services/login.service";
import { ProSessionInfoService } from "@totvs/protheus-lib-core";
import { TemporaryStorageService } from "../services/temporary-storage.service";
import { ThfGridColumn } from "@totvs/thf-components";
import * as _ from 'lodash';
import { PgcLookupService } from "../services/pgc-lookup.service";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class Utils {
  literals: LiteralsWords;
  lBrazil: Boolean;

  constructor(
    private literalsService: LiteralsService,
    private preferencesProfileService: PreferencesProfileService,
    private loginService: LoginService,
    private proSessionInfoService: ProSessionInfoService,
    private temporaryStorageService: TemporaryStorageService,
    private dateHandler: DateHandler,
    private mingleService: MingleService,
    private injector: Injector,
    private router: Router
  ) {
    this.literals = this.literalsService.getLiterals();
    this.lBrazil = sessionStorage.getItem('proPaisLoc') == "BRA";
  }

  //-- Obtém empresa
  getEnterpriseGroup() {
    if (this.loginService.isProtheusLogged()) {
      return this.proSessionInfoService.getCompany()?.Code;
    } else {
      return sessionStorage.getItem('group');
    }
  }

  //-- Obtém filial
  getBranchCode() {
    if (this.loginService.isProtheusLogged()) {
      return this.proSessionInfoService.getBranch()?.Code;
    } else {
      return sessionStorage.getItem('branch');
    }
  }

  //-- Define headers
  getHeaders(noCharset: boolean = false, isInterceptor: boolean = false, url: string = ''): any{
    var group = this.getEnterpriseGroup();
    var branch = this.getBranchCode();
    var paramMultiBranch = this.temporaryStorageService.getValue('paramMultiBranch')
    const language = localStorage.getItem('PO_DEFAULT_LANGUAGE')
    const noCharsetInterceptor = url.includes('framework/environment') || url.includes('oauth2/v1/token'); //-- URLs do frame que não permitem charset

    var multFilBranch = ''
    multFilBranch = this.temporaryStorageService.getValue('branchCode')

    //-- MV_NFCMFIL = .T. realiza a troca da filial de acordo com registro selecionado.
    if(multFilBranch != undefined && multFilBranch.trim() != "" && paramMultiBranch != undefined && paramMultiBranch){
      branch = multFilBranch;
    }

     if (isInterceptor) {
      let headers: any = {};

      headers['tenantId'] = group + ',' + branch;
      headers['Accept-Language'] = language;
      headers['Origin-Route'] = this.router.url;

      if(!noCharsetInterceptor) {
        headers['Accept'] = 'charset=utf8';
      }

      return headers;

    } else {

      let headerOption: Array<HeaderOption> = [];
      if (group && branch) {
        headerOption.push({name: 'tenantId', value: group + ',' + branch});
      }
      headerOption.push({name: 'Accept-Language', value: language});
      headerOption.push({name: 'Origin-Route', value: this.router.url});

      if(!noCharset) {
        headerOption.push({name: 'Accept', value: 'charset=utf8'});
      }

      return headerOption;
    }
  }

  //-- Retorna mensagem de erro da API
  getErrorMessage(error: any): string {
    let errorMessage: string;

    errorMessage = error?.error?.errorMessage;
    errorMessage = errorMessage ? errorMessage : error?.errorMessage;
    errorMessage = errorMessage ? errorMessage : error?.response?.data?.message;
    errorMessage = errorMessage ? errorMessage : error?.response?.data?.errorMessage;
    errorMessage = errorMessage ? errorMessage : error?.message

    return errorMessage;
  }

  //-- Retorna dados o objeto de erro da API
  getErrorData(error: any): string {
    let errorData: string;

    errorData = error?.error;
    errorData = errorData ? errorData : error?.response?.data;
    errorData = errorData ? errorData : error;

    return errorData;
  }

  //-- Resgata os campos customizados de uma tabela
  //-- Retorna em formato de dynamicForm
  //-- sessionStorageItem -> nome que foi gravado a estrutura da tabela no resolver(Ex: struct)
  //-- alias -> nome da tabela da estrutura (Ex: SC1)
  //-- readOnly -> apenas leitura
  //-- optionFields -> retorna os campos desejados - 1=Todos; 2=Apenas do sistema; 3=Apenas de usuário; 4=Apenas obrigatórios; 5=De usuário e Browse
  getAllFields(sessionStorageItem: string = '', alias: string = '', readOnly: boolean = false, optionFields: number = 1): Array<PoDynamicFormField>{
    let struct = this.temporaryStorageService.getValue(sessionStorageItem);
    let fields: Array<PoDynamicFormField> = [];
    let fieldMask = ''
    let comboOptions = [];
    let canChange = true;

    if(struct != undefined){
      let fieldsStruct = struct[alias]?.['fields'];

      if (optionFields > 1) {
        if(optionFields === 5){
          fieldsStruct = fieldsStruct.filter((element)=>element.userField === true && element.browse == true); 
        }else if (optionFields === 4) {
          fieldsStruct = fieldsStruct.filter((element)=>element.userField === false && element.required == true);
        } else {
          const isUserFields: boolean = optionFields === 3;
          fieldsStruct = fieldsStruct.filter((element)=>element.userField === isUserFields);
        }
      }

      if(fieldsStruct != undefined && fieldsStruct.length > 0){
        fieldsStruct.forEach((field)=>{

            //--Campos numéricos
          if(field.type == 'N'){
            fieldMask = field.picture.replace('@E','')
            canChange = field.canChange

            fields.push({
              label: field.required ? `${field.title}*` : field.title,
              property: field.field,
              required: field.required,
              minLength: 0,
              maxLength: field.decimal ? field.size + field.decimal: field.size + 1,
              decimalsLength: field.decimal,
              type: 'currency',
              //mask: fieldMask,
              gridColumns: 3,
              gridSmColumns: 3,
              readonly: !canChange,
              disabled: readOnly
            });

            //--Campos data
          }else if(field.type == 'D'){

            canChange = field.canChange

            fields.push({
              label: field.required ? `${field.title}*` : field.title,
              property: field.field,
              required: field.required,
              type: 'date',
              format: 'dd/mm/yyyy',
              gridColumns: 3,
              gridSmColumns: 3,
              readonly: !canChange,
              disabled: readOnly
            });

            //--Campos lógicos
          }else if(field.type == 'L'){
            canChange = field.canChange;
            
            fields.push(
              {
                property: field.field,
                label: field.required ? `${field.title}*` : field.title,
                gridColumns: 3,
                gridSmColumns: 3,
                type: 'boolean',
                booleanTrue: this.literals.str0099, //-- Sim
                booleanFalse: this.literals.str0100, //-- Não
                disabled: readOnly || !canChange
              });

            //--Campos combo box
          }else if(field.type == 'C' && field.combobox.length > 0){
            let option;
            let fieldCombo = field.combobox;
            canChange = field.canChange

            fieldCombo.forEach((item)=>{
              option = item.split('=')
              if(option.length == 2){
                comboOptions.push({
                  value: option[0],
                  label: option[1]
                });
              }
            });

            if(comboOptions.length > 0){
              fields.push(
                {
                  type: 'po-combo',
                  property: field.field,
                  label: field.required ? `${field.title}*` : field.title,
                  gridColumns: 3,
                  gridSmColumns: 3,
                  options: comboOptions,
                  fieldLabel: 'label',
                  fieldValue: 'value',
                  required: field.required,
                  disabled: readOnly || !canChange
                },
              );
            }

            comboOptions = [];

            //--Campos caracter
          }else{

            let gridColumnsSize = field.size > 60 ? 12 : 3
            canChange = field.canChange

            fields.push({
              type: 'input',
              label: field.required ? `${field.title}*` : field.title,
              property: field.field,
              required: field.required,
              minLength: 0,
              maxLength: field.size,
              gridColumns: gridColumnsSize,
              gridSmColumns: gridColumnsSize,
              readonly: !canChange,
              disabled: readOnly
            });

            if (field.type === 'M') {
              fields[fields.length-1].maxLength = null;
              fields[fields.length-1].gridColumns = 12;
              fields[fields.length-1].rows = 3;
              fields[fields.length-1].type = 'textarea';
            }
          }

          fields[fields.length-1]['folder'] = field.folder;

        })
      }

    }

    return fields;
  }

  //-- Resgata os campos de browser de uma tabela
  //-- sessionStorageItem -> nome que foi gravado a estrutura da tabela no resolver(Ex: structSC1)
  //-- alias -> nome da tabela da estrutura (Ex: SC1)
  getBrowserFields(sessionStorageItem: string = '', alias: string = ''){
    let struct = this.temporaryStorageService.getValue(sessionStorageItem);

    let browserFields = [];

    if(struct != undefined){
      browserFields = struct[alias]['fields'].filter((element)=>element.browse == true && element.virtual == false);
    }

    return browserFields
  
  }

   //-- Obtém picture de um campo de acordo com a estrutura da tabela
   getFieldPicture(sessionStorageItem: string = '', alias: string = '', field: string): string {
    let picture: string = '';
    let struct = this.temporaryStorageService.getValue(sessionStorageItem);
    const fieldStruct = struct[alias]?.['fields']?.find((element) => element?.field == field.toUpperCase());
    
    if (fieldStruct !== undefined && fieldStruct?.picture) {
      picture = fieldStruct.picture;
      picture = picture.replace('@E ', ''); //-- Remove '@E ' de campos numéricos
    }

    return picture;
  }

  getFolders(sessionStorageItem: string = '', alias: string = ''): Array<any> {
    let struct = this.temporaryStorageService.getValue(sessionStorageItem);
    let folders: Array<any> = [];

    if(struct != undefined){
      folders = struct[alias]['folders'];
      folders.push({id: '' , title: this.literals.str0472});
    }

    return folders;
  }

  getFieldsFromFolder(sessionStorageItem: string = '', alias: string = '', folder: string, optionFields: number = 1, readOnly: boolean = false) {
    const fields: Array<any> = this.getAllFields(sessionStorageItem, alias, readOnly, optionFields);
    let fieldsStruct: Array<any> = [];

    fields.forEach(field => {
      if (field.folder.trim() === folder.trim()) {
        fieldsStruct.push(field);
      }
    });
    return fieldsStruct;
  }

  //-- Obtém o nome do campo
  getFieldName(sessionStorageItem: string = '', alias: string = '', field: string = '', mustAsterisk: boolean = false): string {
    let name: string = '';
    let struct = this.temporaryStorageService.getValue(sessionStorageItem);
    const fieldStruct = struct?.[alias]?.['fields']?.find((element) => element?.field == field?.toUpperCase());
    
    if (fieldStruct !== undefined && fieldStruct?.title) {
      name = fieldStruct?.title;

      if (fieldStruct?.required && mustAsterisk) {
        name += '*';
      }
    }

    return name;
  }

  //-- Obtém tamanho do campo
  getFieldSize(sessionStorageItem: string = '', alias: string = '', field: string): number {
    let size: number = 0;
    let struct = this.temporaryStorageService.getValue(sessionStorageItem);

    if (struct) {
      const fieldStruct = struct[alias]?.['fields']?.find((element) => element?.field == field.toUpperCase());
      
      if (fieldStruct !== undefined && fieldStruct?.size) {
        size = fieldStruct.size;
      }
    }

    return size;
  }

  //-- Obtém decimais do campo
  getFieldDecimal(localStorageItem: string = '', alias: string = '', field: string): number {
    let decimal: number = 0;
    let struct = this.temporaryStorageService.getValue(localStorageItem);

    if (struct) {
      const fieldStruct = struct[alias]?.['fields']?.find((element) => element?.field == field.toUpperCase());
      
      if (fieldStruct !== undefined && fieldStruct?.decimal) {
        decimal = fieldStruct.decimal;
      }
    }

    return decimal;
  }

  //-- Obtém se o campo é obrigatório
  getFieldRequired(sessionStorageItem: string = '', alias: string = '', field: string = ''): boolean {
    let required: boolean = false;
    let struct = this.temporaryStorageService.getValue(sessionStorageItem);
    const fieldStruct = struct?.[alias]?.['fields']?.find((element) => element?.field == field?.toUpperCase());
    
    if (fieldStruct !== undefined && fieldStruct?.required) {
      required = true;
    }

    return required;
  }

  //-- Valida os e-mails informados em um campo, eles podem ser separados por ponto e vírgula ";"
  validateEmail(emails: string): Object {
    let errorMessage: string = '';
    let isInvalid: boolean = false;
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const emailList = emails.split(';');
  
    for (const email of emailList) {
      if (!emailPattern.test(email.trim()) && emails) {
        isInvalid = true;
        errorMessage = this.literals?.str0517; //-- Formato do campo e-mail inválido.
      }
    }
    return {invalid: isInvalid, error: errorMessage};
  }

  //Valida o cpf/cnpj informado em um campo
  validateCpfCnpj(cgc: string, type: string = ''): Object{
    let errorMessage: string = '';
    let isInvalid: boolean = false;
    const cgcPattern = type === 'F' ? /^\d{11}$/ : /^\d{14}$/;  
    
    if(type.trim() != ''){

      if (type && !cgc) {
        isInvalid = true;
        errorMessage = type === 'F'? this.literals?.str0864 : this.literals?.str0865;
  
        return { invalid: isInvalid, error: errorMessage };
      }
      
      if (this.lBrazil){
        if (type !== 'X' && cgc && !cgcPattern.test(cgc)) {
          isInvalid = true;
          errorMessage = type === 'F' ? this.literals?.str0866 : this.literals?.str0867
        }
      }
    }

    return {invalid: isInvalid, error: errorMessage};
  }

  //-- Limpa localStorage
  cleanLocalStorage(): void {
    localStorage.clear();
  }

  // Função para remover caracteres inválidos de todos os campos de string de um objeto
  removeInvalidCharactersFromObject(object: any): any {
    const cleanedObject: any = {};

    for (const key in object) {
      if (object.hasOwnProperty(key)) {
        if (typeof object[key] === 'string') {
          cleanedObject[key] = object[key].replace(/\uFFFD/g, '');
        } else {
          cleanedObject[key] = object[key];
        }
      }
    }

    return cleanedObject;
  }

  // Método para converter um json do localStorage para um objeto
  parseLocalStorageItem(key: string, isSessionStorage: boolean = false): any {
    const item = isSessionStorage ? sessionStorage.getItem(key) : localStorage.getItem(key);
    if (item) {
      try {
        return JSON.parse(item);
      } catch (e) {
        console.error(`Error parsing ${key} from localStorage:`, e);
        return null;
      }
    }
    return null;
  }

  //-- Atribui dados do profile nas colunas de uma tabela.
  setProfileToColumns(sessionStoragegeItem: string, columns: Array<PoTableColumn | ThfGridColumn>): void {
    let columnsProfile: Array<PoTableColumn> = this.getProfile()[sessionStoragegeItem];

    if (Array.isArray(columnsProfile) && columnsProfile.length > 0) {
      columns.forEach((column: PoTableColumn, index) => {
        const columnProfile: PoTableColumn = columnsProfile.find((element: PoTableColumn) => element.property == column.property);
        
        if (columnProfile) {
          column.visible = columnProfile.visible;
          column.fixed = columnProfile.fixed;
          column['order'] = columnProfile['order'] || columnProfile['order'] === 0 ? columnProfile['order'] : index;
        }
      });

      columns.sort((column1, column2) => column1['order'] - column2['order']); //-- Ordena colunas de acordo com o profile
    }
  }

  //-- Obtém profile do sessionStorage
  getProfile(): PgcProfileItem {
    let profileItems: Array<PgcProfileItem> = this.temporaryStorageService.getValue('profile');
    let validProfile: boolean = false;

    if (profileItems) {
      validProfile = (profileItems && profileItems.length > 0 && Object.keys(profileItems[0]).length > 0)
    }

    if (validProfile) { //-- Garante que todas propriedades existirão
      profileItems[0].productGroup                = !!profileItems[0].productGroup
      profileItems[0].sendEmail                   = !!profileItems[0].sendEmail
      profileItems[0].sendConditions              = !!profileItems[0].sendConditions
      profileItems[0].columnsPurchase             = Array.isArray(profileItems[0].columnsPurchase         ) ? profileItems[0].columnsPurchase          : [];
      profileItems[0].columnsQuotes               = Array.isArray(profileItems[0].columnsQuotes           ) ? profileItems[0].columnsQuotes            : [];
      profileItems[0].columnsQuoteItems           = Array.isArray(profileItems[0].columnsQuoteItems       ) ? profileItems[0].columnsQuoteItems        : [];
      profileItems[0].columnsQuoteProposals       = Array.isArray(profileItems[0].columnsQuoteProposals   ) ? profileItems[0].columnsQuoteProposals    : [];
      profileItems[0].columnsApprovalGroupList    = Array.isArray(profileItems[0].columnsApprovalGroupList) ? profileItems[0].columnsApprovalGroupList : [];
      profileItems[0].columnsEntities             = Array.isArray(profileItems[0].columnsEntities         ) ? profileItems[0].columnsEntities          : [];
      profileItems[0].columnsApprovalFlow         = Array.isArray(profileItems[0].columnsApprovalFlow     ) ? profileItems[0].columnsApprovalFlow      : [];
      profileItems[0].isEntity                    = !!profileItems[0].isEntity
      profileItems[0].sendPurchaserWf             = !!profileItems[0].sendPurchaserWf
      profileItems[0].a11yLevel                   = !!profileItems[0].a11yLevel ? profileItems[0].a11yLevel : 'po-a11y-AAA';
      
      profileItems[0].filialFilters               = !!profileItems[0].filialFilters ? profileItems[0].filialFilters : [];
      profileItems[0].defaultFilterData           = !!profileItems[0].defaultFilterData ? profileItems[0].defaultFilterData : {};
      profileItems[0].defaultMyQuotations         = !!profileItems[0].defaultMyQuotations;
      profileItems[0].manualSearch                = !!profileItems[0].manualSearch;
      profileItems[0].defaultPageSizePurchaseReq  = !!profileItems[0].defaultPageSizePurchaseReq ? profileItems[0].defaultPageSizePurchaseReq : '';
      profileItems[0].defaultPurchaserSelect      = !!profileItems[0].defaultPurchaserSelect ? profileItems[0].defaultPurchaserSelect : {};
      profileItems[0].autoSelectBestPrice          = profileItems[0].autoSelectBestPrice !== undefined ? profileItems[0].autoSelectBestPrice : true;
    } else {
      profileItems = this.getProfileDefaultItems();
    }

    return profileItems[0];
  }

  //-- Realiza atualização do profile
  updateProfile(profile: PgcProfileItem): void {
    this.temporaryStorageService.setValue('profile', [profile])
    this.preferencesProfileService.updateProfilePreferences(profile).subscribe();
  }

  //-- Retoruna o objeto padrão do profile
  getProfileDefaultItems(): Array<PgcProfileItem> {
    const profileDefaultItems: Array<PgcProfileItem> = [{
      productGroup: false,
      sendEmail: false,
      sendConditions: false,
      isEntity: false,
      sendPurchaserWf: false,
      columnsPurchase: [],
      columnsQuotes: [],
      columnsQuoteItems : [],
      columnsQuoteProposals: [],
      columnsEntities: [],
      columnsApprovalGroupList: [],
      columnsApprovalFlow: [],
      a11yLevel: 'po-a11y-AAA',
      defaultFilterData: [],
      defaultMyQuotations: false,
      manualSearch: false,
      defaultPageSizePurchaseReq: "",
      defaultPageSizeBuyerPanel: "20",
      defaultPurchaserSelect: {},
      filialFilters: [],
      autoSelectBestPrice: true
    }];

    return profileDefaultItems;
  }

  //-- Pega as colunas e converte em um objeto com as propriedades necessárias para o profile
  getTablePropertiesToProfile(columns: Array<PoTableColumn | ThfGridColumn>): Array<Object> {
    const properties: Array<Object> = [];

    columns.forEach((column: PoTableColumn | ThfGridColumn, index: number) => {
      properties.push({property: column.property, visible: column.visible, fixed: column.fixed, order: index});
    });

    return properties;
  }

  //-- Atualiza a ordem e colunas visíveis em todas as tabelas
  tablesColumnsChange(tables: QueryList<PoTableComponent>, columns: Array<PoTableColumn>): void {
    if (tables && tables.length > 0) {
      tables.forEach((table: PoTableComponent) => { 
        table.onVisibleColumnsChange(columns);
        table.newOrderColumns = columns;
      });
    }
  }

  //-- Define string com o nome da moeda em um array de itens.
  setCurrencies(items: Array<Object>, currencyProperty: string = ''): void {
    const currencies: Array<Object> = this.parseLocalStorageItem('currency');

    if (currencies) {
      items?.forEach((item: Object) => {
        const currency: Object = currencies?.['currencies']?.find(el => el?.['currency'] === item?.[currencyProperty]);
        item[currencyProperty] = currency?.['description'];
      });
    }
  }

  //-- Define data do protheus para o formato do PO-UI
  setDates(items: Array<Object>, dateProperty: string = ''): void {
    items?.forEach((item: Object) => {
      item[dateProperty] = this.dateHandler.fromProtheusFrameDateToStringPoUi(item[dateProperty])
    });
  }

  //-- Incrementa um número ou letra em uma string
  soma1(value: string, maxLength: number): string {
    const digits = '0123456789';  // Conjunto de dígitos
    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';  // Conjunto de letras

    // Função para incrementar um único caractere
    function incrementChar(char: string): string {
      if (digits.includes(char)) { // Se o caractere for um dígito, incrementar dentro do conjunto de dígitos
        const index = digits.indexOf(char);
        return index < digits.length - 1 ? digits[index + 1] : '0';
      } else if (letters.includes(char)) { // Se o caractere for uma letra, incrementar dentro do conjunto de letras
        const index = letters.indexOf(char);
        return index < letters.length - 1 ? letters[index + 1] : 'A';
      }
      return '';
    }

    // Função para incrementar a string completa
    function increment(value: string): string {
      let chars = value.split('');  // Converter a string em um array de caracteres
      let carry = true;  // Variável de carry (vai para o próximo caractere)

      for (let i = chars.length - 1; i >= 0 && carry; i--) { // Iterar pelos caracteres da direita para a esquerda
        const newChar = incrementChar(chars[i]);
        carry = (chars[i] === '9' && newChar === '0') || (chars[i] === 'Z' && newChar === 'A');
        chars[i] = newChar;
      }

      
      if (carry) { // Se ainda houver carry após a iteração
        if (chars[0] === '0') { // Se o primeiro caractere for '0', mudar para 'A'
          chars[0] = 'A';
        } else { // Caso contrário, adicionar '1' ao início da string
          chars.unshift('1');
        }
      }

      return chars.join(''); // Reunir o array de caracteres em uma string
    }
    
    if (value === 'Z'.repeat(maxLength)) { // Se a string de entrada for composta apenas por 'Z's e atingir o comprimento máximo, retornar string vazia
      return '';
    }

    const incremented = increment(value); // Incrementar a string de entrada
    return incremented.length <= maxLength ? incremented : ''; // Retornar a string incrementada se seu comprimento não ultrapassar o limite máximo
  }

  //-- Procura itens repetidos em um array de objetos
  findRepeatedObjects(array: Array<Object>, ignoreProperties: Array<string>): Array<Object> {
    const result: Array<Object> = [];
    const seen: Map<string, Object[]> = new Map();
  
    for (const obj of array) {
      // Armazena os valores das propriedades ignoradas
      const ignoredValues: { [key: string]: any } = {};
  
      // Cria uma cópia do objeto e remove as propriedades a serem ignoradas
      const objCopy = { ...obj };
      for (const prop of ignoreProperties) {
        ignoredValues[prop] = obj[prop];
        delete objCopy[prop];
      }
      
      // Cria uma chave única para o objeto com base nas propriedades restantes
      const key = JSON.stringify(objCopy);
  
      if (seen.has(key)) {
        seen.get(key)?.push(obj);
      } else {
        seen.set(key, [obj]);
      }
      
      // Restaura as propriedades ignoradas no objeto original
      for (const prop of ignoreProperties) {
        obj[prop] = ignoredValues[prop];
      }
    }
  
    // Adiciona todos os objetos repetidos, incluindo o original, ao resultado
    for (const objs of seen.values()) {
      if (objs.length > 1) {
        result.push(...objs);
      }
    }
  
    return result;
  }

  //-- Procura objetos sem valores preenchidos
  findEmptyObjects(array: Array<any>, ignoreProperties: Array<string>): Array<Object> {
    const result: Array<Object> = [];
  
    for (const obj of array) {
      // Cria uma cópia do objeto e remove as propriedades a serem ignoradas
      const objCopy = { ...obj };
      for (const prop of ignoreProperties) {
        delete objCopy[prop];
      }
  
      // Verifica se todas as propriedades restantes estão vazias
      const isEmpty = Object.values(objCopy).every(value => value === null || value === undefined || value === '' || value === 0);
  
      if (isEmpty) {
        result.push(obj);
      }
    }
  
    return result;
  }

  // Criar instâncias do PgcLookupService
  createPgcLookupService(): PgcLookupService {
    const injectorInstance = Injector.create({
      providers: [
        {
          provide: PgcLookupService,
          useClass: PgcLookupService,
          deps: [HttpClient, Injector]
        }
      ],
      parent: this.injector // Importante! Usando o injector principal como parent
    });

    return injectorInstance.get(PgcLookupService);;
  }

  //-- Adiciona serviço do lookup nas colunas da tabela
  addLookupServiceToColumns(columns): void {
    columns.forEach((column: ThfGridColumn) => {
      if (column?.editProperties?.componentEditable == 'lookup') {
        const lookupService: PgcLookupService = this.createPgcLookupService();
  
        const stringSearchService: any = column.editProperties.searchService;
        const tableParams: Array<string> = stringSearchService.split(',');
  
        lookupService.serviceParams.columns = column.editProperties.columns;
        lookupService.serviceParams.endpointURL = 'genericList';
        lookupService.serviceParams.endpointURLParams = `alias=${tableParams[0]}`;
        lookupService.serviceParams.fieldToFilter = column.editProperties.fieldValue;
        lookupService.serviceParams.isFramework = true;
        lookupService.serviceParams.executeRequestByValue = true;
        lookupService.serviceParams.isReadOnly = column.editProperties.readonly
        lookupService.serviceParams.initialQueryString = tableParams[1];
        
        column.editProperties.searchService = lookupService;
      }
    });
  }

  //-- Retorna a estrutura de um campo combobox.
  getFielComboBox(sessionStorageItem: string = '', alias: string = '', field: string = ''): Array<any> {
    let struct = this.temporaryStorageService.getValue(sessionStorageItem);
    const fieldStruct = struct?.[alias]?.['fields']?.find((element) => element?.field == field?.toUpperCase());
    const comboOptions: Array<any> = [];
    
    if (fieldStruct !== undefined && fieldStruct?.combobox) {
      let fieldCombo = fieldStruct.combobox;
      fieldCombo.forEach((item)=>{
        let option = item.split('=')
        if(option.length == 2){
          comboOptions.push({
            value: option[0],
            label: option[1]
          });
        }
      });
    }

    return comboOptions;
  }

  //-- Retorna a label do combo de um campo específico.
  getLabelComboBox(sessionStorageItem: string = '', alias: string = '', field: string = '', option: string = '') {
    const options: Array<any> = this.getFielComboBox(sessionStorageItem, alias, field);

    const optionFiltered: Object = options.find((op: Object) => op['value'] === option);

    if (optionFiltered) {
      return optionFiltered['label'];
    } else {
      return '';
    }
  }

  // Incrementa novas colunas a uma coluna ja renderizada(Exxclusiva para o parametro mv_veiculo).
  insertColumnsVehicle(nameProfileColumns: string, currentColumns: Array<PoTableColumn>, vehicleFields: VehicleField[]) {
    const newColumns: Array<PoTableColumn> = [];   
    const indexGroup = currentColumns.findIndex(col => col.property === 'b1_grupo' && col.label === this.literals?.str0439); 

    // Caso ja exista o b1_grupo na tela, altera o label e deixa o campo visivel
    if(indexGroup !== -1){
      currentColumns[indexGroup].visible  = true
      currentColumns[indexGroup].label    = this.literals?.str0133
    }

    vehicleFields.forEach(field =>{
      // Verifica se a coluna já existe para não duplicar
      const existField = currentColumns.some(col => col.property === field.property);
      if (!existField){
        // Cria o objeto formatado para a PoTableColumn
        newColumns.push({
            property: field.property, 
            type    : 'string',
            label   : field.property == 'productcodite' ? this.literals?.str0853 : this.literals?.str0133, // Cod. Produto e Grupo 
            visible : field.visible,
            ...(field.width ? { width: field.width } : {})
        })
      }  
    })
    
    // Se encontrou colunas novas, atualiza a lista e depois o perfil
    if(newColumns.length > 0){
      currentColumns = [...currentColumns, ...newColumns];
      if(nameProfileColumns !== ''){
        this.setProfileToColumns(nameProfileColumns, currentColumns);
      }
    }

    return currentColumns
  }

}
